
import { Vue } from "vue-property-decorator";
import { NavigationStore } from "@/store/navigation";
export default class AppAcceptCookiesBanner extends Vue {
  NavigationStore: any = NavigationStore;
}
